package com.dwarshb.bms

import androidx.compose.ui.graphics.Color

object ThemeColor {
    val blueGradientBackground = listOf(
        Color(0xFF6A11CB),
        Color(0xFF2575FC)
    )

    val pink = Color(0xFFD81B60)

    val pinkGradientBackgorund = listOf(Color(0xFFEF476F), Color(0xFF8338EC))
}